<template>
  <v-data-table
    height="55vh"
    fixed-header
    :headers="headers"
    :items="this.$store.state.groups"
    :search="search"
    sort-by="rowId"
    class="elevation-1"
  >
    <template v-slot:top>
      <div class="pa-5">
        <div class="row viewList">
          <div class="col-sm-12 col-md-4 col-lg-4">
            <v-select
              v-model="select"
              :items="$store.state.groupCmb"
              item-text="name"
              label="Select"
              persistent-hint
              return-object
              single-line
            ></v-select>
            <!-- <v-select :items="items" v-model="select" label="查詢條件" dense outlined ></v-select> -->
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4">
            <v-text-field
              v-model="queryCon"
              v-bind:label="select.placeholder"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-1">
            <v-btn
              large
              color="primary"
              dark
              class="mb-2"
              aria-setsize="16px"
              block
              @click="query"
              >查詢</v-btn
            >
          </div>
          <div class="col-sm-12 col-md-2 col-lg-1">
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn
                  large
                  color="primary"
                  dark
                  class="mb-2"
                  aria-setsize="16px"
                  v-on="on"
                  block
                  >新增</v-btn
                >
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.groupId"
                            label="群組ID"
                            :disabled="disabled"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.groupName"
                            label="群組名稱"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-select
                            v-model="editedItem.status"
                            :items="$store.state.useStatus"
                            item-text="name"
                            item-value="value"
                            label="使用狀態"
                            dense
                            return-object
                            outlined
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.memo"
                            label="備註"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                  <v-btn color="blue darken-1" text @click="validate" :disabled="!valid"
                    >儲存</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </div>
    </template>
    <!-- <template v-slot:item.actions="{ item }"> -->
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        class="mx-2"
        depressed
        fab
        dark
        small
        color="primary"
        @click="editItem(item)"
      >
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        class="mx-2"
        depressed
        fab
        dark
        small
        color="grey grey lighten-1"
        @click="deleteItem(item)"
      >
        <v-icon dark>mdi-delete</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data></template>
  </v-data-table>
</template>
<script>
export default {
  data: () => ({
    valid: true,
    search: '',
    dialog: false,
    disabled: false,
    select: { name: '請選擇', value: null },
    selectS: { name: '請選擇', value: '' },
    queryCon: '',
    headers: [
      //{ text: '', value: 'rowId', sortable: false },
      { text: '群組ID', value: 'groupId' },
      { text: '群組名稱', value: 'groupName' },
      { text: '使用狀態', value: 'status.name' },
      {
        text: '備註',
        align: 'start',
        sortable: false,
        value: 'memo'
      },
      { text: '建立人員', value: 'creatUser' },
      { text: '建立時間', value: 'creatTime' },
      { text: '異動人員', value: 'actUser', sortable: false },
      { text: '異動時間', value: 'actTime' },

      { text: '', value: 'actions', sortable: false }
    ],
    userData: [],

    editedIndex: -1,
    editedItem: {},
    defaultItem: {
      sysGroupId: '',
      groupName: '',
      useStatus: '',
      memo: '',
      creatUser: '',
      creatTime: '',
      actUser: ''
      //actTime: '2020-03-31'
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? '新增群組' : '群組維護'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {},

    editItem(item) {
      this.disabled = true
      this.editedIndex = this.$store.state.groups.indexOf(item)
      this.editedItem = Object.assign({}, item)
      //this.$store.state.users = Object.assign({}, item)
      window.console.log(this.editedItem)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.$store.state.groups.indexOf(item)
      confirm('確認是否刪除此帳號?') && this.delete(item.sysGroupId, index)
    },
    delete(sysGroupId, index) {
      let url = this.$store.state.api + '/S00020/DelGroup'
      let data = Object.assign({ sysGroupId: sysGroupId })
      this.axios.post(url, this.qs.stringify(data)).then(res => {
        if (res.data.resultCode == '10') {
          this.$store.state.groups.splice(index, 1)
          alert('刪除成功!!')
        } else {
          alert(res.data.error)
        }
      })
    },
    close() {
      this.disabled = false
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    validate() {
      this.$refs.form.validate()
      if (this.editedIndex > -1) {
        //修改
        let url = this.$store.state.api + '/S00020/ActGroup'
        let data = Object.assign(
          { sysGroupId: this.editedItem.sysGroupId },
          { groupId: this.editedItem.groupId },
          { groupName: this.editedItem.groupName },
          { statusId: this.editedItem.status.value },
          { memo: this.editedItem.memo }
        )
        this.axios.post(url, this.qs.stringify(data)).then(res => {
          if (res.data.resultCode == '10') {
            Object.assign(this.$store.state.groups[this.editedIndex], this.editedItem)
            this.query()
             this.close()
          } else {
            alert(res.data.error)
             this.close()
          }
        })
      } else {
        //新增
        let url = this.$store.state.api + '/S00020/AddGroup'
        let data = Object.assign(
          { groupId: this.editedItem.groupId },
          { groupName: this.editedItem.groupName },
          { statusId: this.editedItem.status.value },
          { memo: this.editedItem.memo }
        )

        this.axios.post(url, this.qs.stringify(data)).then(res => {
          if (res.data.resultCode == '10') {
            this.$store.state.groups.push(this.editedItem)
            this.query()
             this.close()
          } else {
            alert(res.data.error)
             this.close()
          }
        })
      }
     
    },
    query() {
      let url = this.$store.state.api + '/S00020/query'
      let data = Object.assign({ queryType: this.select }, { queryCon: this.queryCon })
      window.console.log(data)
      this.axios.post(url, this.qs.stringify(data)).then(res => {
        //先把store舊的清掉
        this.$store.state.groups.splice(0)
        if (res.data.resultCode == '10') {
          var rows = res.data.rows
          for (var i = 0; i < res.data.rows.length; i++) {
            var row = rows[i]
            row.status = {
              name: row.statusName,
              value: row.statusId
            }
            this.$store.state.groups.push(row)
            window.console.log(row)
          }
        } else {
          alert(res.data.error)
        }
      })
    }
  }
}
</script>
